import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=49976ee6&scoped=true&"
import script from "./Undo.vue?vue&type=script&lang=js&"
export * from "./Undo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49976ee6",
  null
  
)

export default component.exports